module.exports = __webpack_public_path__ + "static/media/filterReceiver.e726d058.png";